import { render } from "./cart_wholesale.vue?vue&type=template&id=2332a99c&scoped=true"
import script from "./cart_wholesale.vue?vue&type=script&lang=js"
export * from "./cart_wholesale.vue?vue&type=script&lang=js"

import "./cart_wholesale.vue?vue&type=style&index=0&id=2332a99c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2332a99c"]])

export default __exports__